<template>
  <div v-if="chat" :class="$style.circle" :style="wrapperStyle">
    <img
      v-if="chat.imgLink"
      :src="chat.imgLink" alt="chat photo"
      :class="$style.image"
    >
    <template v-else>{{ placeholder }}</template>
  </div>
</template>

<script>
import Avatar from './Avatar'
import { getColorById } from '@/utils/helpers'
import { formattedUserName } from '@/helpers'

export default {
  name: 'avatar-group',
  extends: Avatar,
  props: {
    chat: Object
  },
  computed: {
    placeholder () {
      if (!this.chat.name) return
      return this.chat.name.split(' ').map(word => formattedUserName(word)[0]).join('').substr(0, 2).toUpperCase()
    },
    colors () {
      if (this.chat.imgLink) return
      return getColorById(this.chat.id)
    }
  }
}
</script>
